<template>
  <div class="magic">
    <div
      v-if="isLoading"
      class="loading"
    >
      <span class="fa fa-2x fa-spinner fa-spin" />
    </div>
    <template v-else>
      <template v-if="showOnly">
        <div
          v-for="suggested in added_attributes.suggesteds"
        >
          {{ suggested.name }}
        </div>
      </template>
      <template v-else>
        <suggest
          :clear-on-select="true"
          :url="`/employee/suggest/${suggest_type}s`"
          :include="include"
          :exclude="exclude"
          :placeholder="placeholder != null ? placeholder : trans('core.add_object', { 'object': trans(`core.${suggest_type}`) }) + '...'"
          @select="addSuggested"
        />

        <div
          v-for="suggested in added_attributes.suggesteds"
          :key="suggested.id"
          class="md-checkbox"
        >
          <input
            :id="'label-' + suggested.id"
            v-model="output.suggesteds"
            type="checkbox"
            :value="suggested.id"
            @change="deleteSuggested($event)"
          >
          <label :for="'label-' + suggested.id">{{ suggested.name }}</label>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import uniqBy from 'lodash'
import { defaultErrorMessage } from '@/helpers'

export default {

  props: {
    value: {
      type: [Array, Object],
      required: false,
      default: () => [],
    },
    suggest_type: {
      required: true,
      type: String,
    },
    showOnly: {
      type: Boolean,
      default: false,
    },
    include: {},
    exclude: {},
    placeholder: {},
  },

  data () {
    return {
      isLoading: true,
      ready: false,
      from: { 'name': 'select-choose', 'params': {} },
      text: false,
      errors: null,
      output: {
        suggesteds: [],
      },
      added_attributes: {
        suggesteds: [],
      },
    }
  },

  watch: {
    value: {
      handler (newVal, oldVal) {
        this.output = {
          suggesteds: [],
        }
        this.added_attributes = {
          suggesteds: [],
        }
        this.updateOutput()
      },
      immediate: true,
    },
  },

  methods: {
    updateOutput () {
      this.isLoading = true

      if (this.value !== null) {
        if (Array.isArray(this.value)) {
          this.value.forEach(val => {
            this.output.suggesteds.push(val)
          })
        } else {
          Object.values(this.value).forEach(val => {
            this.output.suggesteds.push(val)
          })
        }

        axios.post(`/employee/suggest/${this.suggest_type}s`, {
          include: { id: this.output.suggesteds },
        }).then(response => {
          let data = response.data

          _.forEach(this.output.suggesteds, value => {
            for (let key in data) {
              if (String(data[key].id).toLowerCase() == String(value).toLowerCase()) {
                this.added_attributes.suggesteds.push({
                  name: data[key].name || this.trans('filters.errors.unknown_object'),
                  id: value,
                })
              }
            }
          })

          this.added_attributes.suggesteds = _.uniqBy(this.added_attributes.suggesteds, 'id')
        }).catch(error => defaultErrorMessage(error))
          .finally(() => this.isLoading = false)
      } else {
        this.isLoading = false
      }
    },

    updateValue (event) {
      this.$emit('input', event.target.value)
    },

    addSuggested (id, value) {
      if (!this.output.suggesteds.includes(id)) {
        this.output.suggesteds.push(id)
        this.added_attributes.suggesteds.push({ name: value, id: id })
      }

      this.$emit('input', this.output.suggesteds)
      this.$emit('added', this.output.suggesteds)
    },

    deleteSuggested (event) {
      if (event.target.checked === false) {
        this.added_attributes.suggesteds = this.added_attributes.suggesteds.filter(e => e.id != event.target.value)// array2 = array2.filter(e => e !== event.target.value);
      }

      this.$emit('input', this.output.suggesteds)
      this.$emit('deleted', this.output.suggesteds)
    },
  },
}
</script>

<style scoped>
    /*.range-input, input, .result-display {*/
    /*width: auto;*/
    /*display: inline-block;*/
    /*vertical-align: middle;*/
    /*}*/

    /*input {*/
    /*width: 300px;*/
    /*max-width: 100%;*/
    /*margin: 0 15px;*/
    /*}*/

    .loading {
        text-align: center;
        margin-top: 10px;
    }

  .label-show{
    border-radius:2px;
    background:none;
    color:black
  }

</style>
